export const APPEND_OBJECT_PROPERTY = 'APPEND_OBJECT_PROPERTY';
export const ENROLLMENT_EVENT_PROPERTY = 'ENROLLMENT_EVENT_PROPERTY';
export const FETCHED_OBJECT_PROPERTY = 'FETCHED_OBJECT_PROPERTY';
export const FIELD_DATA = 'FIELD_DATA';
export const INCREMENT = 'INCREMENT';
export const OBJECT_PROPERTY = 'OBJECT_PROPERTY';
export const RELATIVE_DATETIME = 'RELATIVE_DATETIME';
export const STATIC_APPEND_VALUE = 'STATIC_APPEND_VALUE';
export const STATIC_VALUE = 'STATIC_VALUE';
export const TIMESTAMP = 'TIMESTAMP';
export const SINGLE_OBJECT_COORDINATES = 'SINGLE_OBJECT_COORDINATES';
export const MULTI_VALUE = 'MULTI_VALUE';
export const ENROLLMENT_DATASET_COLUMN = 'ENROLLMENT_DATASET_COLUMN';